export enum DraftSettingType  {
    None = 0,
    UseDraft = 1,
    UseShoppingCart = 2,
    Custom = 3
}